import { useClientTranslations } from "../../lib/i18n/client";
import type { OnboardingAnswers } from "../../types/onboarding";
import styles from "./OnboardingFooter.module.css";

interface OnboardingFooterProps {
	isAnswered: boolean;
	isLoading: boolean;
	isLastScreen: boolean;
	onNext: () => void;
	questionType?: string;
	answers?: OnboardingAnswers;
	onInputChange?: (field: string, value: string | string[]) => void;
	onShowValidation?: () => void;
	showValidation?: boolean;
}

export function OnboardingFooter({
	isAnswered,
	isLoading,
	isLastScreen,
	onNext,
	questionType,
	onShowValidation,
	showValidation = false,
}: OnboardingFooterProps) {
	const { t, isRTL } = useClientTranslations("onboarding");
	const buttonText = isLastScreen ? t("buttons.complete") : t("buttons.next");
	const hasError = showValidation && !isAnswered;

	return (
		<div className={styles.container}>
			{questionType === "fertility-status" && hasError && (
				<p className={styles.errorText}>{t("fertilityStatus.error")}</p>
			)}
			{questionType === "fertility-role" && hasError && (
				<p className={styles.errorText}>{t("fertilityRole.error")}</p>
			)}
			{questionType === "fertility-journey-types" && hasError && (
				<p className={styles.errorText}>{t("fertilityJourneyTypes.error")}</p>
			)}
			{questionType === "needs-most" && hasError && (
				<p className={styles.errorText}>{t("needsMost.error")}</p>
			)}
			{questionType === "how-did-you-hear" && hasError && (
				<p className={styles.errorText}>{t("howDidYouHear.error")}</p>
			)}
			<div className={styles.buttonWrapper}>
				<button
					type="button"
					onClick={() => {
						if (isLoading) {
							return; // Don't do anything if loading
						}

						if (
							!isAnswered &&
							onShowValidation &&
							(questionType === "personal-info" ||
								questionType === "setup-profile" ||
								questionType === "setup-profile-details" ||
								questionType === "fertility-status" ||
								questionType === "fertility-role" ||
								questionType === "fertility-journey-types" ||
								questionType === "journey-steps" ||
								questionType === "cycle" ||
								questionType === "needs-most" ||
								questionType === "how-did-you-hear")
						) {
							onShowValidation();
						} else if (isAnswered) {
							onNext();
						}
					}}
					className={`${styles.button} ${isLastScreen ? styles.buttonComplete : styles.buttonNext} ${!isAnswered || isLoading ? styles.buttonDisabled : ""} ${(questionType === "fertility-status" || questionType === "fertility-role" || questionType === "fertility-journey-types" || questionType === "needs-most" || questionType === "how-did-you-hear") && hasError ? styles.buttonError : ""}`}
					dir={isRTL ? "rtl" : "ltr"}
				>
					{buttonText}
					<span className={styles.arrow}>→</span>
				</button>
			</div>
		</div>
	);
}
